module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-store-info",
    attrs: {
      "src": _vm.info.image_name
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/upBrand/' + _vm.info.id
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary inherit"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.name) + " (" + _vm._s(_vm.info.id) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱縮寫")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.name_short) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱別名")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.nameAliasDisplay) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("代碼(鍵值)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.brand_code) + " (" + _vm._s(_vm.info.brand_key) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排序")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.sort) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                標語\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.slogan) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info.comment) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訊息\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.comment) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                描述\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.description) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.introduction) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌頁介紹\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.introduction) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.email) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                信箱\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.email) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.youtube_video_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                Youtube影片代碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.youtube_video_code) + "\n              ")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌上架\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.info.is_opening) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未上架")]) : _vm._e(), _vm._v(" "), (_vm.info.is_opening) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已上架")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                前端顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.info.is_visible) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未顯示")]) : _vm._e(), _vm._v(" "), (_vm.info.is_visible) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("顯示")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                刪除\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.info.is_delete) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("刪除")]) : _vm._e(), _vm._v(" "), (!_vm.info.is_delete) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("未刪除")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最後更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.edit_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.create_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("聯名圖")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('img', {
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.info.logo_name
    }
  })])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info.photo_name) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("底圖")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('img', {
    staticStyle: {
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.info.photo_name
    }
  })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info.meal_tag_setting.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                餐點種類\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.info.meal_tag_setting), function(mealSetting) {
    return _c('span', {
      staticClass: "label label-success m-b-5 m-r-5"
    }, [_vm._v(_vm._s(mealSetting.name))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.info.website_setting.length) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.info.website_setting), function(setting, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                    " + _vm._s(setting.name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": setting.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(setting.url))])])])
  }), 0)])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("資訊")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連結")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b07f090"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/BrandInfo.vue
// module id = 2409
// module chunks = 1